import React from 'react';
import { Button, Pagesection } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import { useTools } from '../../tools/Tools';
import { ToolNames } from '../../tools/ToolNames';
import useResetUI from '../../tools/reset/useResetUi';

const GenericError = () => {
  const { t } = useTranslation('agisviewer');
  const { label, icon } = useTools()[ToolNames.reset];
  const resetUI = useResetUI();

  const onClearHandler = async () => {
    await resetUI();
    window.location.reload();
  };

  return (
    <Pagesection type="broad">
      <h1 style={{ fontSize: 'var(--typo-size-2)' }}>{t('error_title')}</h1>
      <p>{t('error_reset_text')}</p>
      <Button onClick={onClearHandler} label={t(label)} icon={icon} />
    </Pagesection>
  );
};

export default GenericError;
